import i18next from 'i18next';
import React from 'react';
import en from './i18n/en';

i18next.addResourceBundle('en', 'auth', en);

const authConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	routes: [
		{
			path: '/auth/login',
			component: React.lazy(() => import('./login'))
		},
		{
			path: '/auth/forgot-password',
			component: React.lazy(() => import('./forgot-password'))
		},
		{
			path: '/auth/mail-confirm',
			component: React.lazy(() => import('./mail-confirm'))
		},
		{
			path: '/auth/reset-email',
			component: React.lazy(() => import('./reset-email'))
		},
		{
			path: '/auth/user-activate',
			component: React.lazy(() => import('./user-activate'))
		},
		{
			path: '/auth/register',
			component: React.lazy(() => import('./register'))
		},
		{
			path: '/auth/reset-password',
			component: React.lazy(() => import('./reset-password'))
		}
	]
};

export default authConfig;